import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
//import propertytypesApi from "../../api/propertytype";
import IntlMessages from '../../components/IntlMessage';
import {
  Button,
  Card,
  Table,
  Modal,
  Switch,
  Row,
  Col,
  Image,
  Space,
} from 'antd';
import PageTitle from '../../components/PageTitle';
//import ServiceForm from "./PropertytypesForm";
import _, { debounce } from 'lodash';
import { useIntl } from 'react-intl';
import ActionBar from '../../components/ActionBar';
import FilterBar from '../../components/FilterBar';
import DestinationsForm from './DestinationsForm';
import destinationsApi from '../../api/destinations';
import countriesApi from '../../api/countries';
import { truncateText } from '../../utils/helpers';
import Language from '../../components/Language';
import langsApi from '../../api/langs';
import LanguageForm from './LanguageForm';

Destinations.propTypes = {
  items: PropTypes.array,
};
Destinations.defaultProps = {
  items: [],
};

function Destinations(props) {
  const isMount = useRef(false);

  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(1);
  const [item, setItem] = useState(null);
  // const [deleting, setDeleting] = useState(false);
  const [loading, setLoading] = useState(true);
  const [reload, setReload] = useState(true);
  const [condition, setCondition] = useState({});
  const [country, setCountry] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [LanguageModal, setLanguageModal] = useState(false);
  const [code, setCode] = useState(false);

  const [filter, setFilter] = useState({
    page: 1,
    limit: 10,
    keyword: '',
    order_by: 'id',
    order_dir: 'DESC',
  });
  const [modal, setModal] = useState(false);

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      let items = await destinationsApi.getAll(filter);

      setItems(items.data);
      setLoading(false);
      // setDeleting(false);
      if (total !== items.total) setTotal(items.total);
    }
    fetchData();
  }, [filter, reload]);

  useEffect(() => {
    isMount.current = true;
    async function fetchData() {
      if (isMount) {
        var filter = {
          page: 1,
          limit: 1000,
          keyword: '',
          order_by: 'title',
          order_dir: 'ASC',
        };
        let countries = await countriesApi.getAll(filter);
        setCountry(countries.data);
      }
    }
    fetchData();
    return () => {
      isMount.current = false;
    };
  }, []);

  useEffect(() => {
    if (filter?.filter_name && filter?.filter_value) {
      const newCondition = _.zipObjectDeep(
        filter?.filter_name,
        filter?.filter_value,
      );
      setCondition(newCondition);
    }
  }, [filter]);

  const onChangeTable = async (
    pagination,
    filters,
    sorter,
    extra = { currentDataSource: [] },
  ) => {
    setFilter({
      ...filter,
      page: pagination.current,
      limit: pagination.pageSize,
      order_dir: getOrder(sorter.order),
      order_by: sorter.columnKey ? `${sorter.columnKey}` : 'id',
    });
  };

  const onFilter = debounce(async (value, title, type) => {
    if (type === 'search') {
      setFilter((filter) => {
        return { ...filter, keyword: value, page: 1 };
      });
    } else {
      const filter_obj = { ...condition, [title]: value };
      let filter_name = [];
      let filter_value = [];
      for (var key in filter_obj) {
        if (filter_obj[key]) {
          filter_name.push(key);
          filter_value.push(filter_obj[key]);
        }
      }
      setFilter((filter) => {
        return {
          ...filter,
          filter_name: filter_name,
          filter_value: filter_value,
        };
      });
    }
  }, 300);

  const onReload = () => {
    setReload((reload) => !reload);
  };

  const onOpenModal = (record = null) => {
    setModal(true);
    setItem(record);
    // console.log(record);
  };

  const onCloseModal = () => {
    setModal(false);
  };

  const intl = useIntl();
  // const onRemove = (data) => {
  //   Modal.confirm({
  //     title: intl.formatMessage({ id: 'global.delete_confirm' }),
  //     okText: intl.formatMessage({ id: 'global.yes' }),
  //     onOk: async () => {
  //       await destinationsApi.delete(data.id).catch((error) => {
  //         console.error(error);
  //         Modal.error({
  //           title: error.data.message,
  //           okText: intl.formatMessage({ id: 'global.close' }),
  //         });
  //         setLoading(false);
  //       });
  //       setDeleting(true);
  //     },
  //     onCancel() {},
  //   });
  // };
  const onChangeFeatured = async (ischecked, record) => {
    // console.log(ischecked);
    await destinationsApi.update(record.id, { featured: ischecked });
    setItems((items) =>
      items.map((data) => {
        if (data.id === record.id)
          return {
            ...data,
            featured: ischecked,
          };
        return data;
      }),
    );
  };
  const onChangeStatus = async (ischecked, record) => {
    // console.log(ischecked);
    await destinationsApi.updateStatus(record.id, { status: ischecked });

    setItems((items) =>
      items.map((data) => {
        if (data.id === record.id)
          return {
            ...data,
            status: ischecked,
          };
        return data;
      }),
    );
  };

  const getOrder = (order) => {
    if (order === 'ascend') return 'ASC';
    if (order === 'descend') return 'DESC';
    return 'DESC';
  };

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const onDelete = async (selectedRowKeys) => {
    // console.log('Deleted');
    await destinationsApi.delete(selectedRowKeys).catch((error) => {
      console.error(error);
      Modal.error({
        title: error.data.message,
        okText: intl.formatMessage({ id: 'global.close' }),
      });
      setLoading(false);
    });
    setSelectedRowKeys([]);
    // setDeleting(true);
    onReload();
  };

  const onOpenLanguageModal = async (record, code) => {
    if (record) {
      const items = await langsApi.getAlLanguages({
        page: 1,
        limit: 9999,
        filter_name: ['record_id', 'table', 'code'],
        filter_value: [`${record.id}`, `destinations`, `${code.code}`],
      });
      // console.log('hop-addons: ', items);
      record.language = items.data;
      setItem(record);
      setCode(code);
      setLanguageModal(true);
    } else {
      setModal(true);
      setItem(record);
      // console.log(record);
    }
  };

  const onCloseLanguageModal = () => {
    setLanguageModal(false);
  };

  const columns = [
    // {
    //   title: <IntlMessages id="global.cover_image" />,
    //   key: 'cover_image',
    //   width: 80,
    //   dataIndex: 'cover_image',
    //   render: (text, record) => {
    //     return record.cover_image ? (
    //       <Image
    //         style={{ borderRadius: '3px' }}
    //         width={50}
    //         src={record.img_small ? record.img_small : record.cover_image}
    //       />
    //     ) : (
    //       ''
    //     );
    //   },
    // },
    {
      title: <IntlMessages id="global.name" />,
      key: 'title',
      sorter: true,

      dataIndex: 'title',
      render: (text, record) => {
        return (
          <Space>
            <Space.Compact direction="vertical">
              <Row>
                <Button
                  type="link"
                  size="small"
                  onClick={() => onOpenModal(record)}
                  shape="round"
                  style={{ paddingLeft: '0px' }}>
                  {truncateText(record.title, 10)}
                </Button>
              </Row>
              <Row>
                <Language
                  record={record}
                  showLanguageModal={onOpenLanguageModal}
                />
              </Row>
            </Space.Compact>
          </Space>
        );
      },
    },

    {
      title: <IntlMessages id="global.country" />,
      key: 'country',
      sorter: true,

      dataIndex: 'country',
      render: (text, record) => {
        return `${record.country_title}`;
      },
    },

    {
      title: <IntlMessages id="tour.featured" />,
      key: 'featured',
      // sorter: true,

      dataIndex: 'featured',
      render: (text, record) =>
        record ? (
          <Switch
            checkedChildren={''}
            unCheckedChildren={''}
            checked={!!text}
            onChange={(ischecked) => onChangeFeatured(ischecked, record)}
          />
        ) : null,
    },

    {
      title: <IntlMessages id="global.status" />,
      dataIndex: 'status',
      width: 100,
      key: 'status',
      render: (e, record) =>
        record ? (
          <Switch
            checkedChildren={''}
            unCheckedChildren={''}
            checked={!!e}
            onChange={(ischecked) => onChangeStatus(ischecked, record)}
          />
        ) : null,
    },
    {
      title: <IntlMessages id="global.id_number" />,
      key: 'id',
      width: 20,
      sorter: true,
      dataIndex: 'id',
      render: (text, record, index) => {
        return record.id;
      },
    },
  ];

  return (
    <Card bordered={false} style={{ minHeight: '100%' }}>
      <Row justify="space-between">
        <Col>
          {' '}
          <PageTitle title={<IntlMessages id="global.destination" />} />
        </Col>

        <Col>
          <ActionBar
            onDelete={() => onDelete(selectedRowKeys)}
            isShowAddButton={true}
            onAdd={onOpenModal}
            onRefresh={() => onReload()}
            isShowPublishButtons={false}
            deleteMessage={
              'Vous êtes sur le point de supprimer cette ville et les enregistrements qui lui sont associés. Voulez-vous vraiment supprimer cette ville ?'
            }
            isShowCopyButton={false}
            isShowDeleteButton={true}
            isDisabled={!(selectedRowKeys.length > 0)}></ActionBar>
        </Col>
      </Row>

      <FilterBar
        onFilter={onFilter}
        data={[
          {
            name: 'country',
            data: country,
            placeholder: <IntlMessages id="global.select_country" />,
          },
        ]}></FilterBar>

      <br />

      <Table
        tableLayout="auto"
        columns={columns}
        dataSource={items}
        onChange={onChangeTable}
        rowKey="id"
        size="small"
        loading={loading}
        scroll={{
          x: 'max-content',
        }}
        pagination={{
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '50'],
          total: total,
          current: filter.page,
          pageSize: filter.limit,
        }}
        rowSelection={rowSelection}
      />
      {modal ? (
        <DestinationsForm
          open={modal}
          onClose={onCloseModal}
          currentData={item}
          onReload={onReload}
        />
      ) : null}
      {LanguageModal ? (
        <LanguageForm
          open={LanguageModal}
          onClose={onCloseLanguageModal}
          currentData={item}
          onReload={onReload}
          code={code}
        />
      ) : null}
    </Card>
  );
}

export default Destinations;
